
import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as LoginIcon } from "../fontello/icons/svg/ic_login.svg"


const Login = ({ ...props }) => (
  <SvgIcon
    component={LoginIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Login
